﻿import { setRequired, setVisibility } from "../helpers";
import { initLoadingStateButtons } from "../helpers";

let hasValidatedOnce = false;
const dom = {};

export function initDeclaration() {
    if (document.getElementById("depotServiceDeclarationForm")) {
        cacheDom();

        document.addEventListener('sds-upload:file-added', handleUploadChanged);
        document.addEventListener('sds-upload:file-removed', handleUploadChanged);
        initializeScreen();

        dom.form.addEventListener('submit', () => { hasValidatedOnce = true; });

        dom.beneficiaryRadios.forEach(radio => {
            radio.addEventListener('change', toggleAccountInput);
        });

        dom.declarationKindRadios.forEach(radio => {
            radio.addEventListener('change', toggledeclarationKindInput);
        });

        [dom.constructionAmount, dom.sustainabilityAmount].forEach(elem => {
            if (!elem) {
                return;
            }
            elem.addEventListener('input', updateTotalAmount);
        });

        dom.cancel.addEventListener('click', showCancelDialog);

        dom.continue.addEventListener('click', () => {
            window.dialog.close();
        });
    }
}

function cacheDom() {
    dom.form = document.getElementById('depotServiceDeclarationForm');

    dom.mainUpload = document.querySelector('[data-name="MainUploads.UploadIds"]');
    dom.additionalUpload = document.querySelector('[data-name="AdditionalUploads.UploadIds"]');
    dom.areMaximumFileSizesValid = document.getElementById('AreMaximumFileSizesValid');

    dom.dataShowBeneficiaryChoice = document.querySelector('[data-show-parent="BeneficiaryChoice"]');

    dom.ownAccountNotification = document.querySelector('[data-beneficiary="own"]');
    dom.contractorAccountNotification = document.querySelector('[data-beneficiary="contractor"]');

    dom.constructionAmount = document.getElementById('ConstructionAmount');
    dom.sustainabilityAmount = document.getElementById('SustainabilityAmount');
    dom.totalAmount = document.getElementById('TotalAmount');
    dom.totalAmountShown = document.getElementById('TotalAmountShown');

    dom.constructionLabel = document.querySelector('div[data-form-field]:has(#ConstructionAmount)');
    dom.constructionTypeLabel = document.querySelector('div[data-form-field]:has(#ConstructionDeclarationType)');
    dom.sustainabilityLabel = document.querySelector('div[data-form-field]:has(#SustainabilityAmount)');
    dom.sustainabilityTypeLabel = document.querySelector('div[data-form-field]:has(#SustainabilityDeclarationType)');

    dom.beneficiaryRadios = document.querySelectorAll('input[name="BeneficiaryChoice.Value"]');
    dom.declarationKindRadios = document.querySelectorAll('input[name="DeclarationKind.Value"]');
    dom.dataShowDeclarationKinds = document.querySelectorAll('[data-show-parent="DeclarationKind"]');
    dom.dataShowMainUploads = document.querySelectorAll('[data-show-parent="MainUploads"]');
    dom.cancel = document.getElementById('cancelBtn');
    dom.continue = document.getElementById('continueBtn')
}

function initializeScreen() {
    handleUploadChanged();
    initLoadingStateButtons();
    setInitialRequired();
    toggleAccountInput();
    toggledeclarationKindInput();
}

function handleUploadChanged() {
    showMainUploadChildren();
    updateMaximumFileSizesValidity();
}

function showMainUploadChildren() {
    if (dom.mainUpload.querySelectorAll('li.file').length > 0) {
        dom.dataShowMainUploads.forEach(child => {
            setVisibility(child, true);
        });
    }
}

async function updateMaximumFileSizesValidity() {
    const mainUploadIds = getUploadIds('MainUploads.UploadIds');
    const additionalUploadIds = getUploadIds('AdditionalUploads.UploadIds');

    const query = new URLSearchParams();

    mainUploadIds.forEach(uploadId => {
        query.append('mainUploadIds', uploadId);
    });

    additionalUploadIds.forEach(uploadId => {
        query.append('additionalUploadIds', uploadId);
    });

    const maxTotalFileSizeMb = dom.mainUpload.dataset.maxTotalSizeMb
    const maxTotalFileSize = maxTotalFileSizeMb * 1024 * 1024;
    query.append('maxTotalFileSize', maxTotalFileSize.toString());

    const response = await fetch(`/Depots/CheckMaximumFileSizes?${query.toString()}`, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    });

    if (!response.ok) {
        dom.areMaximumFileSizesValid.value = 'false';
        return;
    }

    const isValid = await response.json();
    dom.areMaximumFileSizesValid.value = String(isValid);

    toggleUploadError(dom.mainUpload, isValid);
    toggleUploadError(dom.additionalUpload, isValid);
}

function toggleUploadError(uploadRoot, isValid) {
    if (!uploadRoot) {
        return;
    }

    const input = uploadRoot.querySelector('input[type="file"]');
    const validationMessage = uploadRoot.closest('fieldset').querySelector('[data-valmsg-for]');
    const field = uploadRoot.closest('[data-form-field]');

    if (isValid) {
        input?.classList.remove('input-validation-error');
        input?.setAttribute('aria-invalid', 'false');

        if (field) {
            field.classList.remove('is-invalid');
        }

        if (validationMessage) {
            validationMessage.textContent = '';
            validationMessage.classList.remove('field-validation-error');
            validationMessage.classList.add('field-validation-valid');
        }

        return;
    }

    input?.classList.add('input-validation-error');
    input?.setAttribute('aria-invalid', 'true');

    if (field) {
        field.classList.add('is-invalid');
    }


    if (validationMessage) {
        validationMessage.textContent = uploadRoot.dataset.errorTotalSize;
        validationMessage.classList.remove('field-validation-valid');
        validationMessage.classList.add('field-validation-error');
    }
}

function getUploadIds(fieldName) {
    return [...document.querySelectorAll(`input[name="${fieldName}"]`)]
        .map(input => input.value)
        .filter(value => value);
}

function setInitialRequired() {
    [...(dom.constructionTypeLabel && dom.sustainabilityTypeLabel
        ? ["ConstructionDeclarationType", "SustainabilityDeclarationType"]
        : [])
    ].forEach(formFieldName => {
        const elem = document.querySelector(`.form-field[data-form-field-name="${formFieldName}"]`);
        setRequired(elem, false)
    });
}

function toggleAccountInput() {
    const value = [...dom.beneficiaryRadios].find(r => r.checked)?.value;
    if (value === "") {
        return;
    }

    const isContractor = value === 'Contractor';

    setVisibility(dom.dataShowBeneficiaryChoice, isContractor);
    setVisibility(dom.ownAccountNotification, !isContractor);
    setVisibility(dom.contractorAccountNotification, isContractor);
}

function toggledeclarationKindInput() {
    const value = [...dom.declarationKindRadios].find(r => r.checked)?.value;

    if (value === 'Receipt') {
        dom.dataShowDeclarationKinds.forEach(child => {
            setVisibility(child, child.dataset.showParentValue.includes('Receipt'));
        });
    } else if (value === "Invoice") {
        dom.dataShowDeclarationKinds.forEach(child => {
            setVisibility(child, child.dataset.showParentValue.includes('Invoice'));
        });
    }

    revalidate();
}

function updateTotalAmount() {
    let constructionAmount = 0;
    let sustainabilityAmount = 0;

    if (dom.constructionAmount) {
        constructionAmount = normalizeDecimal(dom.constructionAmount.value);
        clearIfZero(dom.constructionAmount, constructionAmount);
    }

    if (dom.sustainabilityAmount) {
        sustainabilityAmount = dom.sustainabilityAmount ? normalizeDecimal(dom.sustainabilityAmount.value) : 0;
        clearIfZero(dom.sustainabilityAmount, sustainabilityAmount);
    }

    const totalAmount = constructionAmount + sustainabilityAmount;
    dom.totalAmount.value = totalAmount;
    dom.totalAmountShown.textContent = formatEuro(totalAmount);

    toggleRequiredStars(constructionAmount, sustainabilityAmount);

    revalidate();
}

function revalidate() {
    if (hasValidatedOnce) $(dom.form).valid();
}

function normalizeDecimal(amount) {
    const normalized = amount.replace(/\./g, '').replace(',', '.');
    const value = parseFloat(normalized);
    return isNaN(value) ? 0 : value;
}

function formatEuro(amount) {
    // Convert 1003.25 → "€ 1.003,25"
    return amount
        .toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
        .replace('EUR', '€');
}

function clearIfZero(input, value) {
    if (value !== 0) return;

    input.value = '';
}

function toggleRequiredStars(constructionAmount, sustainabilityAmount) {
    if (!(dom.constructionLabel && dom.sustainabilityLabel)) return;

    const bothZero = constructionAmount === 0 && sustainabilityAmount === 0;

    dom.constructionLabel.classList.toggle('is-required', constructionAmount > 0 || bothZero);
    dom.sustainabilityLabel.classList.toggle('is-required', sustainabilityAmount > 0 || bothZero);

    dom.constructionTypeLabel.classList.toggle('is-required', constructionAmount > 0);
    dom.sustainabilityTypeLabel.classList.toggle('is-required', sustainabilityAmount > 0);
}

function showCancelDialog(event) {
    event.preventDefault();
    window.dialog.open({ elemId: 'cancel-dialog', size: "small" });
}